<template>
  <page-header title="Ticket baja masiva" :breadcrumRoutes="routes">
    <template #tags>
      <tags color="processing">ID: {{ ticketId }}</tags>
    </template>

    <template
      #buttons
      v-if="stateTicketButtonExecute || stateTicketButtonCancel"
    >
      <a-space wrap :size="8">
        <a-button @click="handleCancel" :loading="loading" :disabled="loading">
          Cancelar
        </a-button>
        <a-button
          @click="() => (updateEndDateVisible = true)"
          :disabled="loading"
          :loading="loading"
        >
          Editar fecha de término
        </a-button>
        <a-button
          @click="handlePreSuccess"
          :loading="loading"
          :disabled="loading"
          type="primary"
        >
          Ejecutar
        </a-button>
      </a-space>
    </template>
  </page-header>

  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="updateEndDateVisible"
    title="Editar fecha de término"
    @ok="updateEndDate"
  >
    <a-alert
      message="Importante"
      description="Sólo se actualizará la fecha de término de los tickets que están en revisión aseguradora y no se modificará el Excel que se subió al crear el ticket de baja masiva."
      type="warning"
      show-icon
    />
    <a-date-picker
      class="mt-2"
      format="DD-MM-YYYY"
      style="width: 100%"
      v-model:value="newEndDate"
    />
  </a-modal>

  <massive-tickets-list
    title="Listado de bajas"
    defaultRedirect="BajaMasivaDetail"
    @table-change="onTableChange"
    @set-tickets-data="setExclusionsData"
  />

  <a-card class="mt-4">
    <a-row :gutter="[16, 8]">
      <a-col :xs="24" :md="12">
        <ticket-data
          :data="tableData"
          title="Datos ticket"
          :loadTicket="loadTicket"
        />
        <insurance-message class="mt-3" :message="insuranceMessage" />
      </a-col>

      <a-col :xs="24" :md="12">
        <attached-documents
          title="Documentos adjuntos"
          :data="attachedFiles"
          :loading="loadingDocument"
        />
        <processed-file
          class="mt-3"
          title="Archivo procesado"
          :ticketGroupId="ticketId"
          :loading="loadingMovementFiles"
        />
        <attached-documents
          class="mt-3"
          title="Archivos opcionales"
          :data="attachedOptionalFiles"
          :loading="loadingOptionalFiles"
        />
        <comments
          v-if="userRole != 'rrhh'"
          class="mt-3"
          :comments="comments"
          ticketType="masive"
          :idToTicket="ticketId"
          @new_comment="getNewCommment"
        />
      </a-col>
    </a-row>
  </a-card>

  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="showModalCancel"
    @ok="handleOk"
    centered
    title="Cancelación de ticket de baja masiva"
    :maskClosable="false"
  >
    <a-typography class="mb-4">
      Para cancelar el ticket de baja masiva debe enviar un email a la compañía
      aseguradora.
    </a-typography>

    <a-form
      name="form"
      layout="vertical"
      ref="formRef"
      :model="formState"
      :rules="rules"
    >
      <a-typography-title class="text-gray-8 fw-regular mb-1" strong :level="4">
        Email de cancelación para compañía aseguradora
      </a-typography-title>
      <a-typography-title
        class="text-gray-8 fw-regular mb-1"
        strong
        :level="5"
      ></a-typography-title>
      <a-col :span="24" class="mt-4">
        <a-form-item has-feedback name="message">
          <a-textarea :rows="4" v-model:value="formState.message" />
        </a-form-item>
      </a-col>
      <a-col :span="24" class="mt-4">
        <a-form-item has-feedback name="fileList">
          <a-upload
            name="avatar"
            v-model:fileList="formState.fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <a-button>
              <upload-outlined></upload-outlined>
              Subir archivo
            </a-button>
          </a-upload>
        </a-form-item>
      </a-col>
    </a-form>
    <template #footer>
      <a-row type="flex" justify="end">
        <a-col>
          <a-space>
            <a-button
              key="submit"
              type="default"
              @click="handleCancelExclusionButton"
            >
              Volver atrás
            </a-button>
            <a-button
              key="submit"
              type="primary"
              :loading="loading"
              @click="handleCancelExclusion"
            >
              Confirmar
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </template>
  </a-modal>

  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="visible"
    :title="modalStyle.title"
    @ok="handleOk"
    centered
    :maskClosable="false"
  >
    <a-typography-title class="text-gray-4 fw-regular mb-4" :level="4">
      {{ modalStyle.text }}
    </a-typography-title>
    <a-row :gutter="16" align="middle">
      <a-col :span="3" class="mr-2">
        <info-circle-outlined
          v-if="modalStyle.contentText !== 'Sin casos pendientes'"
          :style="{ fontSize: '21px', color: '#FAAD14' }"
        />
        <check-circle-outlined
          v-if="modalStyle.contentText === 'Sin casos pendientes'"
          :style="{ fontSize: '21px', color: '#00DC92' }"
        />
      </a-col>
      <a-col :span="20">
        <a-typography-title class="text-gray-4 fw-regular ml-2" :level="5">
          {{ modalStyle.contentText }}
        </a-typography-title>
      </a-col>
    </a-row>

    <template #footer>
      <a-row type="flex" justify="end">
        <a-col>
          <a-space>
            <a-button @click="handleOk">Volver atrás</a-button>
            <a-button
              v-if="modalStyle.mode === 'successTicket'"
              key="submit"
              type="primary"
              :loading="loading"
              @click="handleSuccess"
            >
              Confirmar
            </a-button>
          </a-space>
        </a-col>
      </a-row>
    </template>
  </a-modal>
</template>

<script>
import { reactive, ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { InfoCircleOutlined, CheckCircleOutlined } from '@ant-design/icons-vue';
import moment from 'moment';
// Store
import { message } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import {
  GET_AM_DETAIL_FILE,
  FETCH_AM_DETAIL_FILE,
  TICKET_GROUPS_FETCH_TICKET_GROUP,
  TICKET_GROUPS_GET_TICKET_GROUP,
  TICKET_GROUPS_FETCH_TICKETS,
  // PRECANCEL_MASSIVE_INCORPORATION,
  PRESUCCESS_MASSIVE_INCORPORATION,
  SUCCESS_MASSIVE_EXCLUSION,
  CANCEL_MASSIVE_EXCLUSION,
  FETCH_MASSIVE_COMMENTS,
  GET_LOGGED_USER,
  FETCH_USER_BY_ID,
  UPDATE_END_DATE_BEFORE_FINISH_MASSIVE_EXCLUSION,
  FETCH_TICKET_GROUP_OPTIONAL_FILES,
  GET_TICKET_GROUP_OPTIONAL_FILES,
  TICKET_GROUPS_FETCH_MOVEMENT_FILES
} from '@/store/types';
import parseDate from '@/utils/dateFormatter';
// Components
import PageHeader from '@/components/page-header.vue';
import Tags from '@/components/tags.vue';
import TicketData from '@/components/tickets/ticket-data.vue';
import Comments from '@/components/tickets/comments.vue';
import InsuranceMessage from '@/components/tickets/insurer-message.vue';
import AttachedDocuments from '@/components/tickets/attached-documents.vue';
import MassiveTicketsList from '@/components/tickets/massive-tickets-list.vue';
import ProcessedFile from '@/components/tickets/processed-file.vue';
// Utils
import openNotificationWithIcon from '@/utils/notifications';
import rutHelper from '@/utils/Ruts';

export default {
  name: 'BajaMasivaDetail',
  components: {
    'upload-outlined': UploadOutlined,
    comments: Comments,
    'ticket-data': TicketData,
    'insurance-message': InsuranceMessage,
    'attached-documents': AttachedDocuments,
    'processed-file': ProcessedFile,
    'massive-tickets-list': MassiveTicketsList,
    'info-circle-outlined': InfoCircleOutlined,
    'check-circle-outlined': CheckCircleOutlined,
    'page-header': PageHeader,
    tags: Tags
  },
  setup() {
    const rules = {
      message: [
        {
          required: true,
          message: 'Ingrese un mensaje',
          trigger: 'change',
          type: 'string'
        }
      ],
      fileList: [
        {
          type: 'array',
          required: true,
          message: 'Adjunte un archivo',
          trigger: 'change'
        }
      ]
    };
    const headerStateData = reactive({
      text: '',
      color: '',
      showCancelAndExecuted: false,
      revisado_disabled: false,
      show_buttons: true
    });
    const route = useRoute();
    const formRef = ref();
    const nameFile = ref('');
    const store = useStore();
    const ticketId = ref(route.params.id);

    const updateEndDateVisible = ref(false);
    const newEndDate = ref();

    const updateEndDate = async () => {
      try {
        if (!newEndDate.value) {
          openNotificationWithIcon(
            'error',
            'Error',
            'Debe seleccionar una fecha.'
          );
          return;
        }
        await store.dispatch(UPDATE_END_DATE_BEFORE_FINISH_MASSIVE_EXCLUSION, {
          ticketId: ticketId.value,
          endDate: newEndDate.value.startOf('day').toISOString()
        });
        await getTicketData();
        updateEndDateVisible.value = false;
        newEndDate.value = undefined;
      } catch (error) {
        console.error(error);
        let errMsg = error?.response?.data?.message;
        if (!errMsg) {
          errMsg =
            'Ha ocurrido un error al cambiar la fecha de término. Favor intentar más tarde.';
        }
        openNotificationWithIcon('error', 'Error', errMsg);
      }
    };

    // * Rutas
    const routes = [
      {
        path: '/bajas',
        breadcrumbName: 'Bajas'
      },
      {
        path: '/bajas#massive',
        breadcrumbName: 'Masiva'
      },
      {
        breadcrumbName: `#${ticketId.value}`
      }
    ];

    /* const records = reactive([]); */
    const formState = reactive({
      message:
        'A través del presente correo solicitamos cancelar la información contenida en este correo, debido a que existe un error en el documento adjunto. Se generará otra solicitud con el archivo correcto.',
      fileList: []
    });
    const handleRemove = () => {
      formState.fileList = [];
      formRef.value.validate('fileList');
    };
    const beforeUpload = (file) => {
      nameFile.value = file.name;
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 5) {
        message.error('El archivo excede el peso máximo 5MB');
      } else {
        formState.fileList[0] = file;
      }
      return false;
    };
    //* Get Data
    const ticketData = ref({});
    const router = useRouter();
    const stateTicketButtonExecute = ref(false);
    const stateTicketButtonCancel = ref(false);
    const loadingMassiveTicket = ref(false);
    const loadTicket = ref(false);
    const loadingDocument = ref(false);
    const getTicketData = async () => {
      loadTicket.value = true;
      loadingMassiveTicket.value = true;
      await store
        .dispatch(TICKET_GROUPS_FETCH_TICKET_GROUP, ticketId.value)
        .catch(() => router.push({ name: 'Missing' }));
      ticketData.value = await store.getters[TICKET_GROUPS_GET_TICKET_GROUP];
      if (ticketData.value.typeTicketGroupId != 2) {
        router.push({ name: 'Missing' });
      }
      const stateMasiveTicketButton = ticketData.value.ticketGroups.map(
        (e) => e.states.map((f) => f.state)[0]
      );
      if (stateMasiveTicketButton.length) {
        const d = stateMasiveTicketButton.filter(
          (f) => f.tag == 'Cancelado' || f.tag == 'Ejecutado'
        );
        if (d.length < stateMasiveTicketButton.length) {
          stateTicketButtonExecute.value = true;
          stateTicketButtonCancel.value = true;
        }
      }
      loadTicket.value = false;
      loadingMassiveTicket.value = false;
    };
    getTicketData().then(() => {
      fillTicketGroupData();
      getBroker();
    });

    const filters = ref({});

    const getTicketDataWithPagination = async (pagination) => {
      loadTicket.value = true;
      loadingMassiveTicket.value = true;

      const page = pagination?.current ?? 1;
      const size = pagination?.pageSize ?? 10;

      await store
        .dispatch(TICKET_GROUPS_FETCH_TICKETS, {
          ticketGroupId: ticketId.value,
          filters: filters.value,
          page,
          size
        })
        .catch(() => router.push({ name: 'Missing' }));

      fillExclusionsTable();
      loadTicket.value = false;
      loadingMassiveTicket.value = false;
    };

    const onTableChange = ({ pagination, filters: newFilters }) => {
      filters.value = { ...newFilters };

      const safePagination = {
        current: pagination?.current ?? 1,
        pageSize: pagination?.pageSize ?? 10
      };

      getTicketDataWithPagination(safePagination);
    };

    const attachedFiles = ref([]);
    const getAttachedFiles = async () => {
      loadingDocument.value = true;
      try {
        await store
          .dispatch(FETCH_AM_DETAIL_FILE, ticketId.value)
          .catch((err) =>
            openNotificationWithIcon(
              'error',
              'Error',
              `Error al cargar archivo del Ticket. ${
                err.response.data ? err.response.data.message : 'error'
              }`
            )
          );
        attachedFiles.value = await store.getters[GET_AM_DETAIL_FILE];
        loadingDocument.value = false;
      } catch (error) {
        console.log('error', error);
        openNotificationWithIcon(
          'error',
          'Error',
          error.response.data ? error.response.data.message : 'error'
        );
        loadingDocument.value = false;
      }
    };
    getAttachedFiles();

    const loadingOptionalFiles = ref(false);
    const attachedOptionalFiles = ref([]);
    const getAttachedOptionalFiles = async () => {
      loadingOptionalFiles.value = true;
      try {
        await store.dispatch(FETCH_TICKET_GROUP_OPTIONAL_FILES, ticketId.value);
        attachedOptionalFiles.value = await store.getters[
          GET_TICKET_GROUP_OPTIONAL_FILES
        ];
        loadingOptionalFiles.value = false;
      } catch (error) {
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al cargar archivos opcionales del Ticket. ${error.response.data.message}`
        );
        loadingOptionalFiles.value = false;
      }
    };
    getAttachedOptionalFiles();

    const tableData = reactive([
      { key: 'Fecha de creación', value: '' },
      { key: 'Broker', value: '' },
      { key: 'Aseguradora', value: '' },
      { key: 'Holding', value: '' },
      { key: 'Subholding', value: '' },
      { key: 'Empresa', value: '' },
      { key: 'RUT Empresa', value: '' },
      { key: 'Póliza', value: '' },
      { key: 'Grupo', value: '' }
    ]);
    const insuranceMessage = ref('');

    const fillTicketGroupData = () => {
      tableData[0].value = ticketData.value.object?.createdAt
        ? moment(ticketData.value.object?.createdAt).format('DD/MM/YYYY')
        : '';
      tableData[2].value = ticketData.value.object?.insuranceCompany || '';
      tableData[3].value = ticketData.value.object?.holding || '';
      tableData[4].value = ticketData.value.object?.subHolding || '';
      tableData[5].value = ticketData.value.object?.company || '';
      tableData[6].value = ticketData.value.object?.rutCompany
        ? rutHelper.formatRut(ticketData.value.object.rutCompany)
        : '';

      tableData[7].value = ticketData.value.object?.policies.join(', ') || '';
      tableData[8].value = ticketData.value.object?.groups.join(', ') || '';

      insuranceMessage.value = ticketData.value?.message || '';
    };

    const getBroker = async () => {
      const response = await store.dispatch(
        FETCH_USER_BY_ID,
        ticketData.value.object.brokerId
      );
      tableData[1].value = response.data.body.name;
    };

    const incorporationsData = ref([]);

    const showCancelAndExecute = computed(() =>
      exclusionsData.value.some((d) => {
        console.log('d', d);
        if (d.ticketState == 'CANCELADO' || d.ticketState == 'EJECUTADO') {
          return false;
        }
        return true;
      })
    );
    // const showCancelAndExecute = () => {
    // switch (last) {
    // case 'Creado':
    //   headerStateData.showCancelAndExecuted = true;
    //   headerStateData.text = 'Creado';
    //   headerStateData.color = 'blue';
    //   break;
    // case 'En revision Aseguradora':
    //   headerStateData.showCancelAndExecuted = true;
    //   headerStateData.text = 'En revisión aseguradora';
    //   headerStateData.color = 'gold';
    //   headerStateData.show_buttons = true;
    //   break;
    // case 'Ejecutado':
    //   headerStateData.showCancelAndExecuted = true;
    //   headerStateData.text = 'Ejecutado';
    //   headerStateData.color = 'green';
    //   break;
    // case 'Cancelado':
    //   headerStateData.showCancelAndExecuted = false;
    //   headerStateData.text = 'Cancelado';
    //   headerStateData.color = 'red';
    //   break;
    // default:
    //   // TODO: En caso de que reciba cualquier otro estado que no deba
    //   headerStateData.text = 'holaaaa';
    //   headerStateData.color = 'default';
    //   break;
    // }
    // };
    // showCancelAndExecute();

    const exclusionsData = ref([]);

    const setExclusionsData = (ticketsRows) => {
      exclusionsData.value = ticketsRows;
    };

    const fillExclusionsTable = () => {
      exclusionsData.value = Array.isArray(ticketData.value?.ticketGroups)
        ? ticketData.value.ticketGroups.map((a) => {
            return {
              key: a.id,
              id: a.id,
              policies: a.policies?.map((p) => p.numberPolicy).join(', ') ?? '',
              group: a.groupCompanies?.map((g) => g.name).join(', ') ?? '',
              employeeName: `${a.employee?.firstName ?? ''} ${
                a.employee?.firstSurname ?? ''
              }`.trim(),
              employeeRut: a.employee?.rut
                ? rutHelper.formatRut(a.employee.rut)
                : '',
              ticketState: a.states?.[0]?.state?.id ?? '',
              pendingCases: a.cases === 0 ? 'No' : a.cases ? 'Sí' : ''
            };
          })
        : [];
    };

    const payloadObject = ref({});
    const loading = ref(false);
    const visible = ref(false);
    const showModalCancel = ref(false);
    const modalStyle = reactive({
      title: '',
      text: '',
      contentText: '',
      mode: ''
    });

    const showModal = () => {
      visible.value = true;
      loading.value = false;
    };

    const handleOk = () => {
      visible.value = false;
      loading.value = false;
    };
    const handleCancelExclusionButton = () => {
      showModalCancel.value = false;
    };
    const orderDataTicketMasive = ref();
    const handleCancel = async () => {
      showModalCancel.value = true;
      orderDataTicketMasive.value = ticketData.value.ticketGroups
        .map((e) => e.states.pop())
        .filter((f) => f.state.tag !== 'Ejecutado');
    };
    const handleCancelExclusion = async () => {
      formRef.value.validate().then(async () => {
        loading.value = true;
        try {
          await store.dispatch(CANCEL_MASSIVE_EXCLUSION, {
            idAlta: ticketId.value,
            payload: formState
          });
          await store
            .dispatch(TICKET_GROUPS_FETCH_TICKETS, {
              ticketGroupId: ticketId.value
            })
            .then(() => {
              openNotificationWithIcon(
                'success',
                'Correcto',
                `Ticket ${ticketId.value} cancelado exitosamente`
              );
              getTicketData().then(() => {
                fillTicketGroupData();
                getBroker();
              });
              stateTicketButtonExecute.value = false;
              stateTicketButtonCancel.value = false;
              formState.message =
                'A través del presente correo solicitamos cancelar la información contenida en este correo, debido a que existe un error en el documento adjunto. Se generará otra solicitud con el archivo correcto.';
              formState.fileList[0] = [];
              showModalCancel.value = false;
              loading.value = false;
            });
        } catch (error) {
          loading.value = false;
          openNotificationWithIcon(
            'error',
            'Error',
            `No se ha podido cancelar el ticket ${ticketId.value}. ${
              error.response.data ? error.response.data.message : 'error'
            }`
          );
        }
      });
    };

    const handlePreSuccess = async () => {
      let cantTickets = null;
      let pendingCount = 0;
      await store
        .dispatch(PRESUCCESS_MASSIVE_INCORPORATION, ticketId.value)
        .then((res) => {
          cantTickets = res.ticketSuccess.length;
          if (cantTickets === 0) {
            openNotificationWithIcon(
              'error',
              'Error',
              'No se ha podido cargar la información para ejecutar el ticket. No existe ningún ticket para ejecutar.'
            );
          } else {
            res.ticketPending.map(() => {
              pendingCount++;
            });
            modalStyle.mode = 'successTicket';
            modalStyle.title = 'Ejecutar ticket de baja masiva';
            modalStyle.text = `¿Estás seguro de que deseas ejecutar ${cantTickets} tickets de baja masiva?`;
            if (cantTickets === 1) {
              modalStyle.text = `¿Estás seguro de que deseas ejecutar ${cantTickets} ticket de baja masiva?`;
            }
            modalStyle.contentText =
              pendingCount > 0
                ? `No se están considerando ${pendingCount} tickets pendientes con casos asociados.`
                : 'Sin casos pendientes';
            if (pendingCount === 1) {
              modalStyle.contentText = `No se está considerando ${pendingCount} ticket pendiente con casos asociados.`;
            }
            payloadObject.value = { result: res };
            showModal();
          }
        })
        .catch((err) =>
          openNotificationWithIcon(
            'error',
            'Error',
            `No se ha podido cargar la información para ejecutar el ticket. ${
              err.response.data ? err.response.data.message : 'error'
            }.`
          )
        );
    };

    // Llenar el historial con Comentarios
    /* const fillRecordsWithComents = (data) =>{
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        records.push({
          title:'Nuevo comentario',
          description:element.createdAt
        });
      }
    }; */

    const handleSuccess = async () => {
      loading.value = true;
      try {
        await store.dispatch(SUCCESS_MASSIVE_EXCLUSION, {
          idAlta: ticketId.value,
          payload: payloadObject.value
        });
        await store
          .dispatch(TICKET_GROUPS_FETCH_TICKETS, {
            ticketGroupId: ticketId.value
          })
          .then(() => {
            openNotificationWithIcon(
              'success',
              'Correcto',
              `Ticket ${ticketId.value} ejecutado exitosamente`
            );
            getTicketData().then(() => {
              fillTicketGroupData();
              getBroker();
            });
            loading.value = false;
            stateTicketButtonExecute.value = false;
            stateTicketButtonCancel.value = false;
            visible.value = false;
          });
      } catch (error) {
        loading.value = false;
        openNotificationWithIcon(
          'error',
          'Error',
          `No se ha podido ejecutar el ticket ${ticketId.value}. ${
            error.response.data ? error.response.data.message : 'error'
          }`
        );
      }
    };

    // * Comentarios
    // rol de  usuario
    const userRole = store.getters[GET_LOGGED_USER].roleName;

    // Obtencion de comentarios
    const comments = ref([]);
    const getComments = async () => {
      comments.value = [];
      const resp = await store.dispatch(FETCH_MASSIVE_COMMENTS, ticketId.value);
      for (let i = 0; i < resp.length; i++) {
        const element = resp[i];
        const broker_name = await getBrokerName(element.brokerId);
        comments.value.push({
          description: parseDate(element.createdAt),
          title: element.message,
          author: broker_name
        });
      }
    };

    const getBrokerName = async (id) => {
      const response = await store.dispatch(FETCH_USER_BY_ID, id);
      return response.data.body.name;
    };

    const getNewCommment = async (value) => {
      const { description } = value;
      const { brokerId } = value;
      const brokerName = await getBrokerName(brokerId);

      comments.value.push({
        title: value.title,
        description: parseDate(description),
        author: brokerName
      });
    };

    getComments();

    const loadingMovementFiles = ref(false);

    const getMovementFiles = async (ticketGroupId) => {
      loadingMovementFiles.value = true;
      try {
        await store.dispatch(TICKET_GROUPS_FETCH_MOVEMENT_FILES, ticketGroupId);
      } catch (e) {
        console.error('Error:', e);
      } finally {
        loadingMovementFiles.value = false;
      }
    };

    getMovementFiles(ticketId.value);

    onMounted(async () => {
      await store.dispatch(TICKET_GROUPS_FETCH_TICKETS, {
        ticketGroupId: ticketId.value,
        filters: filters.value,
        page: 1,
        size: 10
      });
    });

    return {
      // Variables
      rules,
      handleCancelExclusion,
      headerStateData,
      formRef,
      beforeUpload,
      handleRemove,
      formState,
      comments,
      loading,
      visible,
      showModalCancel,
      modalStyle,
      incorporationsData,
      exclusionsData,
      routes,
      ticketId,
      tableData,
      insuranceMessage,
      attachedFiles,
      handleCancelExclusionButton,
      userRole,
      showCancelAndExecute,
      // Methods
      handleCancel,
      handlePreSuccess,
      handleSuccess,
      handleOk,
      getNewCommment,
      stateTicketButtonExecute,
      stateTicketButtonCancel,
      loadingMassiveTicket,
      loadTicket,
      loadingDocument,
      updateEndDateVisible,
      newEndDate,
      updateEndDate,
      attachedOptionalFiles,
      loadingOptionalFiles,
      loadingMovementFiles,
      setExclusionsData,
      onTableChange
    };
  }
};
</script>
